(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xxxl-fan-card-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xxxl-fan-card')) {
    customElements.define('xxxl-fan-card', class extends HTMLElement {
      connectedCallback() {
        if (this._abort) return;
        this._abort = new AbortController();
        const markHoverImageReady = image => this.toggleAttribute('data-hover-image-ready', image.naturalWidth > 0);
        this.addEventListener('load', event => {
          if (event.target instanceof HTMLImageElement && event.target.classList.contains('xxxl-fan-card__image--hover')) {
            markHoverImageReady(event.target);
          }
        }, { capture: true, signal: this._abort.signal });
        const hoverImage = this.querySelector('.xxxl-fan-card__image--hover');
        if (hoverImage?.complete) markHoverImageReady(hoverImage);
        this.addEventListener('click', (event) => {
          const choice = event.target instanceof Element ? event.target.closest('[data-xxxl-size-choice]') : null;
          if (!choice || !this.contains(choice) || choice.disabled) return;
          event.preventDefault();
          event.stopPropagation();
          this.querySelectorAll('[data-xxxl-size-choice]').forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
          const price = this.querySelector('[data-xxxl-price]');
          const from = this.querySelector('[data-xxxl-from]');
          if (price) price.textContent = choice.dataset.price;
          if (from) from.dataset.visible = choice.dataset.showFrom;
          this.querySelectorAll('[data-xxxl-product-link]').forEach(link => link.setAttribute('href', choice.dataset.variantUrl));
        }, { signal: this._abort.signal });
      }
      disconnectedCallback() {
        this._abort?.abort(); this._abort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
